export class GoogleAccount {
  clientId;
  description;
  googleClientId;
  id;
  name;
  objectType;
  constructor(obj?: GoogleAccount) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/google-accounts/google-account.model.ts